export enum PlayerViewerType {
  ISC = 'ISC',
  LESSON = 'LESSON',
}



// WEBPACK FOOTER //
// ./ts/app/shared/types/player-viewer-type.enum.ts